import { Spin } from "@bedrock/components";
import React from "react";
import * as ReactDOM from 'react-dom';

const mountDomId = 'loadingDiv';

const defaultOverTime = 60000;

class GlobalLoading {
  static counter = 0;

  static timer = null;

  static overTime = defaultOverTime;

  loading() {
    GlobalLoading.counter++;
    this.show();
    if (!GlobalLoading.timer) {
      GlobalLoading.timer = setInterval(() => {
        GlobalLoading.overTime -= 1000;
        if (GlobalLoading.counter <= 0 || GlobalLoading.overTime <= 0) {
          this.reset();
        }
      }, 1000);
    }
  }

  done() {
    GlobalLoading.counter--;
    if (GlobalLoading.counter <= 0) {
      this.reset();
    }
  }

  destroy() {
    let div = document.getElementById(mountDomId);
    if (!div) return;
    const unmountResult = ReactDOM.unmountComponentAtNode(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
  }

  show = () => {
    let div = document.getElementById(mountDomId);
    if (div) return null;

    div = document.createElement('div');
    div.id = mountDomId;
    div.style.position = 'absolute';
    div.style.zIndex = '9999';
    div.style.backgroundColor = 'transparent';
    document.body.appendChild(div);

    ReactDOM.render(
      <Spin.Global 
        spinning={true} 
        style={{ position: 'fixed', height: '100vh', width: '100vw', top: 0, left: 0, backgroundColor: 'transparent', opacity: 0.6 }}
      />
      ,div
    );
  }

  reset = () => {
    GlobalLoading.counter = 0;
    GlobalLoading.overTime = defaultOverTime;
    clearInterval(GlobalLoading.timer);
    GlobalLoading.timer = null;
    this.destroy();
  }
}

const globalLoading = new GlobalLoading();

export const globalLoadingFn = (fn) => {
  return async (...args) => {
    globalLoading.show();
    try {
      const res = await fn(...args);
    } catch (error) {
      globalLoading.done();
    }
    globalLoading.done();
  }
}

export default globalLoading;
